import React from 'react'
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer,
    Cell
} from "recharts";

// const data = [
//     { "month": "Jan", "users": 123, "queries": 345 },
//     { "month": "Feb", "users": 123, "queries": 123 },
//     { "month": "Mar", "users": 123, "queries": 12 }
// ]
const CustomXAxisTick = ({ x, y, payload }) => {
    if (!payload || !payload.value) return null;
    const words = payload.value.toString().split(/(?=[/\s])/).map(w => w.trim()).filter(Boolean);
    const lines = [];
    let currentLine = [];

    words.forEach(word => {
        if (currentLine.join(" ").length + word.length > 10 && currentLine.length > 0) {
            lines.push(currentLine.join(" "));
            currentLine = [word];
        } else {
            currentLine.push(word);
        }
    });
    if (currentLine.length > 0) {
        lines.push(currentLine.join(" "));
    }

    return (
        <g transform={`translate(${x},${y})`}>
            <text x={0} y={0} dy={14} textAnchor="middle" fill="#4b5563" fontSize={11} fontWeight={500}>
                {lines.map((line, index) => (
                    <tspan textAnchor="middle" x="0" dy={index === 0 ? 0 : 14} key={index}>
                        {line}
                    </tspan>
                ))}
            </text>
        </g>
    );
};
const BarCharts = ({ data, nameKey, title, colors, xAxisName, horizontal = false, onBarClick, xAxisHeight = 75 }) => {
    const enableScroll = data.length > 5;
    const renderLegendText = (value, entry) => {
        return (
            <span style={{ color: "#4b5563", fontSize: "16px", paddingLeft: "4px", fontWeight: "normal" }}>
                {value}
            </span>
        );
    };

    return (
        <div className="w-full h-full flex flex-col">
            <h1 className='text-[#4b5563] text-[16px] font-semibold mb-8 ml-2'>{title}</h1>
            <div className={`flex-1 min-h-0 ${enableScroll && !horizontal ? "overflow-x-auto" : "overflow-x-hidden"}
                                    ${enableScroll && horizontal ? "overflow-y-auto" : "overflow-y-hidden"}`}>
                <div className={`h-full ${enableScroll && !horizontal ? "min-w-[700px]" : "min-w-0"} 
                ${enableScroll && horizontal ? "min-h-[500px]" : "min-h-0"}`}>
                    <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={data} layout={horizontal ? "vertical" : "horizontal"} margin={{ top: 20, right: 30, bottom: 20, left: 0 }}>
                            <CartesianGrid strokeDasharray="3 3" />
                            <XAxis dataKey={nameKey}
                                textAnchor="middle"
                                interval={0}
                                height={xAxisHeight}
                                tickMargin={10}
                                tick={<CustomXAxisTick />} />
                            <YAxis />


                            <Tooltip />
                            <Legend formatter={renderLegendText} wrapperStyle={{ paddingTop: "10px" }} iconType="square" />
                            <Bar
                                dataKey="count"
                                name={xAxisName}
                                legendType="square"
                                label={{
                                    position: "top",
                                    fontSize: 12
                                }}
                                onClick={(data) => onBarClick?.(data)}
                            >
                                {data.map((entry, index) => (
                                    <Cell
                                        key={`cell-${index}`}
                                        fill={colors[index % colors.length]}
                                    />
                                ))}
                            </Bar>

                        </BarChart>
                    </ResponsiveContainer>
                </div>

            </div>


        </div>
    )
}

export default BarCharts
